import React, { Component } from "react";
import { Table } from "antd";

class TableView extends Component {

	constructor(){
		super();
		this.state = {
			mode: 'inline',
    		theme: 'light',
		}
	}
  render() {
	let {loading = false,disablePagination = true, columns, data, onRow, className, rowSelection=null } = this.props;
	return(
		<React.Fragment>
		    <Table rowSelection={rowSelection} onRow={onRow} loading={loading} pagination={{disabled:disablePagination}} columns={columns} dataSource={data} className={className} />
	    </React.Fragment>
	)
  }
}

export default TableView;
